import { render } from "./FontSizeSettings.vue?vue&type=template&id=7cf13798"
import script from "./FontSizeSettings.vue?vue&type=script&lang=js"
export * from "./FontSizeSettings.vue?vue&type=script&lang=js"

import "./FontSizeSettings.vue?vue&type=style&index=0&id=7cf13798&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__